export default __webpack_public_path__ + "static/media/not_required.1b134fbe.svg";